export class Personalizacao {
    pedidoItemId: number = 0
    opcaoId: number = 0
    quantidade: number = 0
    itemCardapioId: number = 0
    clienteId?: string | null = ''
    grupoOpcoesId?: number
}